import React from 'react';
import "./GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import DataTable from '../common/DataTable/DataTable';
import Checkbox from '../common/Checkbox/Checkbox';
import TenantName from './TenantName';

interface OperatingExpensesWizardProps {
    updateWizardFunction : (e: React.ChangeEvent<Element>, i: number, f: string, n?: boolean, c?: boolean) => void;
    tenantList: Record<string, unknown>[];
    floorDescriptionLookup: Record<string, unknown>;
    leaseTypeLookup: Record<string, unknown>;
    // for pagination
    totalPages: number | undefined;
    currentPage: number;
    changePage: (e: number) => void
}

export default function OperatingExpensesWizard(props: OperatingExpensesWizardProps): JSX.Element {
    const { t } = useTranslation("guided_wizard");
    const operatingExpensesList = [
        {"value": "includeInsuranceFlag", "text": t("operating-expenses-wizard.insurance"), "className": " med-column"},
        {"value": "includeManagementFlag", "text": t("operating-expenses-wizard.management"), "className": " med-column"},
        {"value": "includeMaintenanceFlag", "text": t("operating-expenses-wizard.maintenance"), "className": " med-column"},
        {"value": "includePropertyTaxFlag", "text": t("operating-expenses-wizard.property-tax"), "className": " med-column"},
        {"value": "includeHydroFlag", "text": t("operating-expenses-wizard.hydro"), "className": ""},
        {"value": "includeWaterFlag", "text": t("operating-expenses-wizard.water"), "className": ""},
        {"value": "includeHvacFlag", "text": t("operating-expenses-wizard.hvac"), "className": ""}
    ];
    const headings = [<tr key="unit-use-wizard-heading-row-1">
            <th className='small-column' key="operating-expenses-wizard-heading-1" rowSpan={2}>{t("unit-heading.floor-level")}</th>
            <th key="operating-expenses-wizard-heading-2" rowSpan={2}>{t("unit-heading.tenant-name")}</th>
            <th key="operating-expenses-wizard-heading-3" rowSpan={2}>{t("unit-heading.unit-number")}</th>
            <th key="operating-expenses-wizard-heading-4" rowSpan={2}>{t("unit-heading.lease-type")}</th>
            <th key="operating-expenses-wizard-heading-5" colSpan={operatingExpensesList.length}>{t("unit-heading.operating-expenses") + " " + t("unit-heading.select-multiple")}</th></tr>,
        <tr key="unit-use-wizard-heading-row-2">{
            operatingExpensesList.map((option) => <th className={`wizard-option-column${option["className"]}`} key={`unit-use-${option["value"] as string}`}>{option["text"]}</th>)
        }</tr>];

        const buildTableContent = (): JSX.Element => {
            const tableBody: JSX.Element[] = [];
            for (let index = 10 * (props.currentPage - 1); index < Math.min(props.tenantList.length, 10 * props.currentPage); index++) {
                tableBody.push (<tr key={`operating-expenses-wizard-row-${index}`}>
                    <td className='no-input-cell'><label>{props.floorDescriptionLookup[props.tenantList[index]["floorLevel"] as string] as string}</label></td>
                    <td className='no-input-cell tenant-name-cell'><TenantName name={props.tenantList[index]["tenantName"] as string} /></td>
                    <td className='no-input-cell tenant-unit-cell'><p>{props.tenantList[index]["tenantUnitNumber"] as string}</p></td>
                    <td className='no-input-cell'><p>{props.leaseTypeLookup[props.tenantList[index]["leaseTypeCode"] as string] as string}</p></td>
                    {operatingExpensesList.map((operatingExpense) =>
                        <td key={`operating-expenses-wizard-${index}-${operatingExpense["value"]}`} className={"wizard-grey-out-cell center-cell wizard-option-column" + operatingExpense["className"] + ((props.tenantList[index]["leaseTypeCode"] === "1" || props.tenantList[index]["leaseTypeCode"] === "2") ? " no-input-cell" : "")}>{props.tenantList[index]["leaseStatusCode"] !== "1" &&
                            <div className='center-checkbox'><Checkbox name={`operating-expenses-wizard-${index}-${operatingExpense["value"]}`} id={`operating-expenses-wizard-${index}-${operatingExpense["value"]}`} disabled={props.tenantList[index]["leaseTypeCode"] === "1" || props.tenantList[index]["leaseTypeCode"] === "2"}
                                defaultChecked={props.tenantList[index][operatingExpense["value"]] === true} onChange={(e) => props.updateWizardFunction(e, index, operatingExpense["value"], false, true)}/></div>}
                        </td>)
                    }
                </tr>)
            }
            return (<>{tableBody}</>);
        }

    return (<div>
        <p>{t("operating-expenses-wizard.operating-expenses-description")}</p>
        <DataTable headings={headings} multiLineHeading={true} className='wizard-table multires-full-table' totalPages={props.totalPages} currentPage={props.currentPage} changePage={props.changePage}>
            {buildTableContent()}
        </DataTable>
    </div>)
}
